import { makeStyles, lighten, darken } from "@material-ui/core";
import DelcoteGSImage from "Custom/Content/ProductSelector/highlight_delcote_gs.png";
import DelcoteGSHoverImage from "Custom/Content/ProductSelector/highlight_delcote_gs_hover.png";
import DelcoteGSCheckedImage from "Custom/Content/ProductSelector/highlight_delcote_gs_selected.png";
import PlygeneImage from "Custom/Content/ProductSelector/highlight_plygene.png";
import PlygeneHoverImage from "Custom/Content/ProductSelector/highlight_plygene_hover.png";
import PlygeneCheckedImage from "Custom/Content/ProductSelector/highlight_plygene_selected.png";

export const GutterSystemStyle = makeStyles((theme) => ({
    root: {
        backgroundColor: "#F4F5F5",
        marginBottom: "2.5rem",
        padding: "40px 15px",
        [theme.breakpoints.up("sm")]: {
            padding: "40px",
        },
        [theme.breakpoints.up("lg")]: {
            padding: "20px 60px",
        },
    },
    products: {
        display: "flex",
        flexDirection: "column",
        "& > div": {
            display: "flex",
            flex: "1",
            flexDirection: "column",
            margin: "0 0.75rem",
        },
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
        },
    },
    gutterimage: {
        backgroundSize: "contain",
        height: "100%",
        minHeight: "250px",
        width: "auto",
    },
    radioButtons: {
        display: "flex",
        "& > div": {
            flex: "1",
            flexDirection: "column",
        },
        [theme.breakpoints.up("md")]: {
            marginBottom: "2.5rem",
            "& > div": {
                flexDirection: "row",
            },
        },
    },
    radioButton: {
        flex: "1",
        margin: "0 0.75rem 10px 0.75rem",
        maxWidth: "490px",
        "& > span.MuiButtonBase-root": {
            backgroundPosition: "top left",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            borderRadius: "0",
            height: "205px",
            width: "100%",
            "& > span.MuiIconButton-label": {
                display: "none",
            },
        },
        "& > span.MuiFormControlLabel-label": {
            fontFamily: "Nexa Bold",
            fontSize: "18.75px",
            marginBottom: "7.5px",
            marginRight: "auto",
        },
        [theme.breakpoints.up("md")]: {
            margin: "0 0.75rem",
            maxWidth: "395px",
            "& > span.MuiButtonBase-root": {
                backgroundPosition: "top center",
                height: "166px",
            },
        },
        [theme.breakpoints.up("lg")]: {
            maxWidth: "490px",
            "& > div": {
                flexDirection: "row",
            },
            "& > span.MuiButtonBase-root": {
                height: "205px",
            },
        },
    },
    radioButtonPlygene: {
        "& > span.MuiButtonBase-root.Mui-checked": {
            backgroundImage: `url(${PlygeneCheckedImage})`,
        },
        "& > span.MuiButtonBase-root:not(.Mui-checked)": {
            backgroundImage: `url(${PlygeneImage})`,
            "&:hover": {
                backgroundImage: `url(${PlygeneHoverImage})`,
            },
        },
    },
    radioButtonDelcote: {
        "& > span.MuiButtonBase-root.Mui-checked": {
            backgroundImage: `url(${DelcoteGSCheckedImage})`,
        },
        "& > span.MuiButtonBase-root:not(.Mui-checked)": {
            backgroundImage: `url(${DelcoteGSImage})`,
            "&:hover": {
                backgroundImage: `url(${DelcoteGSHoverImage})`,
            },
        },
    },
}));
